// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import Swal from "vue-sweetalert2";
import 'sweetalert2/dist/sweetalert2.min.css';
import store from "../src/store/store";
import VueDraggableResizable from "vue-draggable-resizable";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import "vue-loading-overlay/dist/vue-loading.css";
import Chartkick from "vue-chartkick";
import Chart from "chart.js";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import Notifications from "vue-notification";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import ColorPickerCustom from "./screens/SimpleEdit/ColorPickerCustom";
import vuetify from "@/plugins/vuetify";
import AOS from 'aos'
import 'aos/dist/aos.css'
import imageViewer from "vue-image-viewer";
import excel from 'vue-excel-export'
 
Vue.use(excel)
Vue.use(Notifications);
Vue.use(Chartkick.use(Chart));
Vue.use(require("vue-moment"));
Vue.config.productionTip = false;
Vue.use(Swal, { heightAuto: false, confirmButtonText: `<span style="padding: 0 10px">OK</span>` });
Vue.component("vue-draggable-resizable", VueDraggableResizable);
Vue.component("VueSlider", VueSlider);
Vue.component("ColorPickerCustom", ColorPickerCustom);
Vue.use(imageViewer);

/* eslint-disable no-new */
new Vue({
  created() {
    AOS.init()
  },
  el: "#app",
  vuetify,
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js